import { Link } from 'react-router-dom';
import Logo from '../Logo';
import { PatentPendingStamp } from './PatentPendingStamp';
import { MarketingSocialLinks } from './MarketingSocialLinks';
import { WWW_TAP_TARGET_CLASS } from '../../lib/wwwTapTarget';
import {
  MARKETING_FOOTER_LINK_CLASS,
  MARKETING_FOOTER_NAV_CLASS,
  MARKETING_FOOTER_NAV_TESTID,
  MARKETING_FOOTER_SHELL_CLASS,
} from '../../lib/wwwPhoneClipLayout';

const FOOTER_COLUMNS = [
  {
    heading: 'Product',
    links: [
      { to: '/pricing', label: 'Pricing' },
      { to: '/install', label: 'Install' },
      { to: '/beta', label: 'Get the app' },
      { to: '/intervals', label: 'Intervals setup' },
      { to: '/about', label: 'About' },
    ],
  },
  {
    heading: 'Account',
    links: [
      { to: '/login', label: 'Sign In', wwwControl: 'login' },
      { to: '/register', label: 'Register' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { to: '/terms', label: 'Terms' },
      { to: '/privacy', label: 'Privacy' },
    ],
  },
];

export function MarketingSiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className={`py-10 sm:py-12 border-t border-white/10 ${MARKETING_FOOTER_SHELL_CLASS}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          data-testid={MARKETING_FOOTER_NAV_TESTID}
          className={MARKETING_FOOTER_NAV_CLASS}
        >
          <div className="col-span-2 sm:col-span-1 flex min-w-0 flex-col items-start gap-3">
            <Logo
              size={32}
              variant="white"
              showText
              textClass="text-white"
            />
          </div>
          {FOOTER_COLUMNS.map((column) => (
            <nav
              key={column.heading}
              aria-label={column.heading}
              className="flex min-w-0 flex-col items-start"
            >
              <p className="instrument-page-eyebrow !mb-2 !text-primary-400 text-left">{column.heading}</p>
              {column.links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  data-www-control={link.wwwControl}
                  className={`${MARKETING_FOOTER_LINK_CLASS} ${
                    link.wwwControl ? WWW_TAP_TARGET_CLASS : ''
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          ))}
        </div>
        <MarketingSocialLinks
          className="mt-8 flex items-center justify-center gap-3"
          linkClassName="text-stone-400 hover:text-white transition-colors"
          leading={<PatentPendingStamp className="text-stone-500" />}
        />
        <p className="mt-6 sm:mt-8 text-center text-xs sm:text-sm text-stone-500">
          &copy; {year} FuelCyclePro by Hot Chilli Studios.
        </p>
      </div>
    </footer>
  );
}
